/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Clear_ButtonInputs */



/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Speaker_Manager_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_clear_button = /** @type {((inputs?: Speaker_Manager_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Clear_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiaro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Claro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पष्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Claro")
	return /** @type {LocalizedString} */ ("Clear")
});